"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bannerList = void 0;
exports.bannerList = function (axios) {
    return {
        /** @deprecated getBannerGroups를 사용해주세요(소문자 변경) */
        GetBannerGroups: function (GetBannerGroupsRequest) {
            return axios.get('/banner-groups', GetBannerGroupsRequest);
        },
        getBannerGroups: function (GetBannerGroupsRequest) {
            return axios.get('/banner-groups', GetBannerGroupsRequest);
        },
        /** @deprecated getBannerGroupsBannerSections를 사용해주세요(소문자 변경) */
        GetBannerGroupsBannerSections: function (GetBannerGroupsBannerSectionsRequest) {
            return axios.get("/banner-groups/banner-sections/" + GetBannerGroupsBannerSectionsRequest.params.bannerSectionNo + "?mallNo=" + GetBannerGroupsBannerSectionsRequest.params.mallNo);
        },
        getBannerGroupsBannerSections: function (_a) {
            var params = _a.params;
            return axios.get("/banner-groups/banner-sections/" + params.bannerSectionNo + "?mallNo=" + params.mallNo);
        },
        /** @deprecated postBannerGroups를 사용해주세요(소문자 변경) */
        PostBannerGroups: function (PostBannerGroupsRequest) {
            return axios.post('/banner-groups', PostBannerGroupsRequest);
        },
        postBannerGroups: function (PostBannerGroupsRequest) {
            return axios.post('/banner-groups', PostBannerGroupsRequest);
        },
        /** @deprecated deleteBannerGroupsBannerGroupNo를 사용해주세요(소문자 변경) */
        DeleteBannerGroupsBannerGroupNo: function (DeleteBannerGroupsBannerGroupNoRequest) {
            return axios.delete("/banner-groups/" + DeleteBannerGroupsBannerGroupNoRequest.pathParams.bannerGroupNo + "?mallNo=" + DeleteBannerGroupsBannerGroupNoRequest.pathParams.mallNo);
        },
        deleteBannerGroupsBannerGroupNo: function (_a) {
            var pathParams = _a.pathParams;
            return axios.delete("/banner-groups/" + pathParams.bannerGroupNo + "?mallNo=" + pathParams.mallNo);
        },
        /** @deprecated putBannerGroupBannerGroupNo를 사용해주세요(소문자 변경) */
        PutBannerGroupBannerGroupNo: function (PutBannerGroupBannerGroupNoRequest) {
            return axios.put("/banner-groups/" + PutBannerGroupBannerGroupNoRequest.pathParams.bannerGroupNo, PutBannerGroupBannerGroupNoRequest.data);
        },
        putBannerGroupBannerGroupNo: function (_a) {
            var data = _a.data, pathParams = _a.pathParams;
            return axios.put("/banner-groups/" + pathParams.bannerGroupNo, data);
        },
        /** @deprecated postBannerGroupsBannerGroupNoBannerSections를 사용해주세요(소문자 변경) */
        PostBannerGroupsBannerGroupNoBannerSections: function (PostBannerGroupsBannerGroupNoBannerSectionsRequest) {
            return axios.post("/banner-groups/" + PostBannerGroupsBannerGroupNoBannerSectionsRequest.pathParams.bannerGroupNo + "/banner-sections", PostBannerGroupsBannerGroupNoBannerSectionsRequest.data);
        },
        postBannerGroupsBannerGroupNoBannerSections: function (_a) {
            var pathParams = _a.pathParams, data = _a.data;
            return axios.post("/banner-groups/" + pathParams.bannerGroupNo + "/banner-sections", data);
        },
        /** @deprecated putBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo를 사용해주세요(소문자 변경) */
        PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo: function (PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest) {
            return axios.put("/banner-groups/" + PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest.pathParams.bannerGroupNo + "/banner-sections/" + PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest.pathParams.bannerSectionNo, PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest.data);
        },
        putBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo: function (_a) {
            var pathParams = _a.pathParams, data = _a.data;
            return axios.put("/banner-groups/" + pathParams.bannerGroupNo + "/banner-sections/" + pathParams.bannerSectionNo, data);
        },
        /** @deprecated deleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo를 사용해주세요(소문자 변경) */
        DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo: function (DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest) {
            return axios.delete("/banner-groups/" + DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest.pathParams.bannerGroupNo + "/banner-sections/" + DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest.pathParams.bannerSectionNo + "?mallNo=" + DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest.pathParams.mallNo);
        },
        deleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo: function (_a) {
            var pathParams = _a.pathParams;
            return axios.delete("/banner-groups/" + pathParams.bannerGroupNo + "/banner-sections/" + pathParams.bannerSectionNo + "?mallNo=" + pathParams.mallNo);
        },
        /** @deprecated putBannerGroupsBannerGroupNoOrder를 사용해주세요(소문자 변경) */
        PutBannerGroupsBannerGroupNoOrder: function (PutBannerGroupsBannerGroupNoOrderRequest) {
            return axios.put("/banner-groups/" + PutBannerGroupsBannerGroupNoOrderRequest.pathParams.bannerGroupNo + "/order", PutBannerGroupsBannerGroupNoOrderRequest.data);
        },
        putBannerGroupsBannerGroupNoOrder: function (_a) {
            var pathParams = _a.pathParams, data = _a.data;
            return axios.put("/banner-groups/" + pathParams.bannerGroupNo + "/order", data);
        },
        /** @deprecated putBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder를 사용해주세요(소문자 변경) */
        PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder: function (PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder) {
            return axios.put("/banner-groups/" + PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder.pathParams.bannerGroupNo + "/banner-sections/" + PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder.pathParams.bannerSectionNo + "/order", PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder.data);
        },
        putBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder: function (_a) {
            var pathParams = _a.pathParams, data = _a.data;
            return axios.put("/banner-groups/" + pathParams.bannerGroupNo + "/banner-sections/" + pathParams.bannerSectionNo + "/order", data);
        },
        getBannerSections: function (GetBannerSectionsRequest) {
            return axios.get('/banner-sections', GetBannerSectionsRequest);
        },
        getBannerSectionsDuplicate: function (GetBannerSectionsDuplicateRequest) {
            return axios.get('/banner-sections/duplicate', GetBannerSectionsDuplicateRequest);
        },
        getBannerGroupsInfos: function (GetBannerGroupsInfosRequest) {
            return axios.get('/banner-groups/infos', GetBannerGroupsInfosRequest);
        },
        deleteBannerGroupsBulk: function (DeleteBannerGroupsBulkRequest) {
            return axios.delete('/banner-groups/bulk', DeleteBannerGroupsBulkRequest);
        },
        deleteBannerSections: function (DeleteBannerSectionsRequest) {
            return axios.delete('/banner-sections', DeleteBannerSectionsRequest);
        },
    };
};
